import React from 'react';

import classNames from 'classnames';

import { statuses, statusesText } from './constants';

import styles from './styles.module.scss';

export const StatusInfo: React.FC<sharedComponents.StatusInfo> = ({ status, aqaId, className, statusText }) => (
  <span id={aqaId} className={classNames(styles.status, styles[statuses[status]], className)}>
    {statusText || statusesText[status]}
  </span>
);
